import type { FC } from "react";
import { useEffect } from "react";
import styled from "styled-components";
import { Layout } from "../layout/layout";

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 24px 70px;
  min-height: 60vh;
  background-color: white;
  text-align: center;
`;

const SuccessTitle = styled.h1`
  font-family: 'Amatic SC', cursive;
  font-size: 75.4px;
  color: var(--fy-grey);
  margin-bottom: 120px;
  letter-spacing: 1.89px;
  line-height: 75.4px;

  @media (max-width: 640px) {
    font-size: 50px;
    line-height: 50px;
  }
`;

const SuccessMessage = styled.p`
  font-family: 'Amatic SC', cursive;
  font-size: 50.2px;
  color: var(--fy-grey);
  max-width: 800px;
  letter-spacing: 2.74px;
  line-height: 65px;
  margin-bottom: 100px;

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 42px;
  }
`;

export const SubmissionSuccess: FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <main className="flex-grow bg-white">
        <SuccessContainer>
          <SuccessTitle>Success!</SuccessTitle>
          <SuccessMessage>
            Congratulations! Your form has been submitted successfully.
            We will be in touch with you very soon.
          </SuccessMessage>
        </SuccessContainer>
      </main>
    </Layout>
  );
};

export default SubmissionSuccess; 